import { useEffect, useRef, useState } from 'react'
import clsx from 'clsx'
import { IconChevronLeft, IconChevronRight } from '@tabler/icons'
import { dayjsInit } from '@ow/utils'
import MonthGrid from './month'

const Biennial = ({ value, onChange }) => {
  const [left, right] = value

  const isNear = left >= right - 1
  return (
    <div className="flex justify-between items-center border-b px-2 py-1">
      <div className="flex-1 flex items-center justify-between">
        <div
          className="p-4 cursor-pointer"
          onClick={() => onChange([left - 1, right])}
        >
          <IconChevronLeft size={14} />
        </div>
        <div>{left}</div>
        <div
          className={clsx(
            'p-4 cursor-pointer',
            isNear && 'invisible pointer-events-none'
          )}
          onClick={() => onChange([left + 1, right])}
        >
          <IconChevronRight size={14} />
        </div>
      </div>
      <div className="flex-1 flex items-center justify-between">
        <div
          className={clsx(
            'p-4 cursor-pointer',
            isNear && 'invisible pointer-events-none'
          )}
          onClick={() => onChange([left, right - 1])}
        >
          <IconChevronLeft size={14} />
        </div>
        <div>{right}</div>
        <div
          className="p-4 cursor-pointer"
          onClick={() => onChange([left, right + 1])}
        >
          <IconChevronRight size={14} />
        </div>
      </div>
    </div>
  )
}

const Multi = ({ value, onChange, onClose }) => {
  const { startDate, endDate } = value || {}
  const endYearRef = useRef(dayjsInit(endDate).year())
  const startYearRef = useRef(
    startDate ? dayjsInit(startDate).year() : endYearRef.current - 1
  )
  const [year, setYear] = useState([startYearRef.current, endYearRef.current])

  const [half, setHalf] = useState(false)
  const [start, setStart] = useState(null)
  const [end, setEnd] = useState(null)

  const handleChange = ({ startDate: x, endDate: y }) => {
    if (onChange) {
      onChange({
        startDate: x.startOf('month').toDate(),
        endDate: y.endOf('month').toDate(),
      })
    }
    setTimeout(onClose, 300)
  }

  const onLeftSelect = (i) => {
    ;[startYearRef.current] = year
    if (half) {
      if (start !== null) {
        // 选中同侧
        const v = [start, i].sort((x, y) => x - y)
        setStart(v)
        handleChange({
          startDate: dayjsInit([year[0], v[0]]),
          endDate: dayjsInit([year[0], v[1]]),
        })
      } else {
        // 选中另一侧
        setStart([i])
        setEnd((pre) => [undefined, pre])
        handleChange({
          startDate: dayjsInit([year[0], i]),
          endDate: dayjsInit([year[1], end]),
        })
      }
      setHalf(false)
    } else {
      setStart(i)
      setEnd(null)
      setHalf(true)
    }
  }

  const onRightSelect = (i) => {
    ;[, endYearRef.current] = year
    if (half) {
      if (end !== null) {
        const v = [end, i].sort((x, y) => x - y)
        setEnd(v)
        handleChange({
          startDate: dayjsInit([year[1], v[0]]),
          endDate: dayjsInit([year[1], v[1]]),
        })
      } else {
        setStart((pre) => [pre])
        setEnd([undefined, i])
        handleChange({
          startDate: dayjsInit([year[0], start]),
          endDate: dayjsInit([year[1], i]),
        })
      }
      setHalf(false)
    } else {
      setStart(null)
      setEnd(i)
      setHalf(true)
    }
  }

  const getSelectedValue = (y) => {
    if (y === startYearRef.current) return start
    if (y === endYearRef.current) return end
    if (
      y > startYearRef.current &&
      y < endYearRef.current &&
      !half &&
      start &&
      end
    ) {
      return [-1, 12]
    }
    return null
  }

  useEffect(() => {
    if (startDate && endDate) {
      const left = dayjsInit(startDate)
      const right = dayjsInit(endDate)

      if (left.year() === right.year()) {
        if (left.year() <= startYearRef.current) {
          startYearRef.current = left.year()
          endYearRef.current = startYearRef.current + 1

          setStart([left.month(), right.month()])
          setEnd(null)
        } else {
          endYearRef.current = left.year()
          startYearRef.current = endYearRef.current - 1

          setEnd([left.month(), right.month()])
          setStart(null)
        }
      } else {
        startYearRef.current = left.year()
        endYearRef.current = right.year()

        setStart([left.month()])
        setEnd([undefined, right.month()])
      }
      setYear([startYearRef.current, endYearRef.current])
    } else {
      setStart(null)
      setEnd(null)
    }
  }, [startDate, endDate])

  return (
    <div className="font-weight-bold select-none">
      <Biennial value={year} onChange={setYear} />
      <div className="flex">
        <MonthGrid
          selected={getSelectedValue(year[0])}
          isRange
          isSelecting={half}
          onSelect={onLeftSelect}
        />
        <MonthGrid
          selected={getSelectedValue(year[1])}
          isRange
          isSelecting={half}
          onSelect={onRightSelect}
        />
      </div>
    </div>
  )
}

export default Multi
